<template>
  <div class="contact-info ">
    <v-app-bar
    >
      <div style="margin-left: 25px;" >
        <img :src="get_user_image()" class="circle-img"/>
      </div>
      <v-toolbar-title style="width: 100%">
        <v-row>
          <v-col cols="3">
            <span class="router-name">
          وظایف شما
        </span>
          </v-col>
          <v-col cols="3">
            <v-btn color="primary" class="mr-1" @click="dialog_new=true">وظیفه جدید</v-btn>
            <v-btn color="primary" class="mr-1" @click="$router.push({path:'/tm_report'})">گزارش وظایف</v-btn>
            <v-btn color="primary" class="mr-1" @click="$router.push({path:'/tm_queue_report'})">وظایف در انتظار تایید</v-btn>
          </v-col>

        </v-row>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn style="left:0;position: absolute" v-on:click="$router.go(-1)" v-if='$route.path != "/message-tab"' icon>
        <!--        <v-icon color="black" >mdi-chevron-left</v-icon>-->
        <img src="/img/back_icon.svg" style="    width: 30px;
    height: 30px;
    padding: 6px;"/>
      </v-btn>
    </v-app-bar>

    <div class="row" style="margin-top: 60px;">
      <div v-for="op in tm_operation" class="col-12">
        <v-card outlined style="border:1px solid grey;margin:5px" @click="selected_record=op,dialog_operation=true">
          <v-card-title style="border-bottom:1px solid grey">
            <v-row style="font-size: 15px;">
              <v-col cols="12">
                <label>{{op.OperationTitle}}</label>
                <v-icon color="primary" style="position: absolute;left: 0">mdi-eye</v-icon>
              </v-col>
              <v-col cols="6">
                <label>تاریخ: {{new Date(op.StartDate).toLocaleDateString('fa-IR')}}</label>
              </v-col>
              <v-col cols="6">
                <label>ثبت کننده: {{op.UserNamee}}</label>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                {{op.OperationCode}}
                <label>{{get_type_title(op.MainOperationType)}}</label>
                <label>{{get_op_title(op.OperationType)}}</label>
              </v-col>
              <v-col cols="6">
                <v-chip
                  class="ma-1"
                  color="primary"
                >
                  عامل: {{op.AgentName}}

                </v-chip>
                <v-chip
                  class="ma-1"
                  color="primary"
                >
                  ناظر:{{op.SupervisorName}}

                </v-chip>

                <v-chip
                  class="ma-1"
                  color="primary"
                >
                  سرپرست: {{op.ManagerName}}

                </v-chip>
              </v-col>
              <v-col cols="6">
                <v-chip
                  v-if="op.OperationTypeTitle!=null" v-for="tag in JSON.parse(op.OperationTypeTitle)"
                  class="ma-1"
                  color="success"
                >
                  {{tag.Title}}

                </v-chip>

              </v-col>
              <v-col cols="12">
                <label>
                  {{op.Summary}}
                </label>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </div>

    </div>
    <v-dialog
      v-model="dialog_operation"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      width="100%"
    >
      <v-card class="edit-picture blue-border">
        <v-toolbar
          dark
          class=""

          color="primary"
        >
          <v-toolbar-title>تغییر وضعیت {{selected_record.OperationTitle}}</v-toolbar-title>
          <v-btn
            icon
            dark
            style="    position: absolute;
    left: 0;"
            @click="dialog_operation = false"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>

        </v-toolbar>

        <v-card-text>

          <v-row>
            <v-col cols="12">
              <div v-html="selected_record.Summary"></div>

            </v-col>
            <v-col>
              <v-select
                :items="status_items"
                label="وضعیت را انتخاب کنید."
                item-text="label"
                outlined
                dense
                v-model="selected_status"
                item-value="value"
                single-line
              >
              </v-select>
            </v-col>

            <v-col cols="12" v-if="selected_status==1">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> کاربران </label>
                <div class="col-sm-9">

                  <treeselect

                    v-model="document_person"
                    :async="search_user_async"
                    :multiple="true"
                    :load-options="load_persons"
                    placeholder="جستجو کنید (حداقل 3 حرف)"
                    :normalizer="normalizer_persons"
                  />

                </div>
              </div>
            </v-col>
            <v-col col="12" v-if="selected_record.MainOperationType==2">
              <v-text-field
                horizontal
                outlined
                type="number"
                label="مقدار فعلی"
                v-model="current_value"/>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="توضیحات"
                horizontal
                outlined
                v-model="change_status_summary"
              />
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" @click="add_status()">ثبت وضعیت</v-btn>
            </v-col>
            <v-col cols="12" v-if="selected_record.Images!=null">
<p>پیوست ها</p>
   <v-row>
     <v-col cols="3" v-for="img in JSON.parse(selected_record.Images)">
       <a target="_blank" :href="'https://'+img.ArchivePath+'/'+img.FileName">
<img width="100%" :src="'https://'+img.ArchivePath+'/'+img.FileName"/>
       </a>
     </v-col>
   </v-row>
            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_new"
      fullscreen
      scrollable
      transition="dialog-bottom-transition"
      width="100%"
    >
      <v-card class="edit-picture blue-border">
        <v-toolbar
          dark
          class="arrow-left"
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog_new = false"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <!--                <v-toolbar-title>گالری</v-toolbar-title>-->
          <v-spacer></v-spacer>

        </v-toolbar>

        <v-card-text style="background: #b9b9b9">
          <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">
            <v-col cols="12 col-sm-6 col-lg-3">
              <v-text-field
                horizontal
                outlined
                dense

                label="عنوان"
                v-model="new_title"/>
            </v-col>
            <v-col cols="12 col-sm-6 col-lg-3">
              <v-select
                :items="tm_cats"
                label="دسته بندی"
                outlined
                dense

                item-text="Title"
                v-model="selected_cat"
                item-value="RecId"
                single-line
              >
              </v-select>
            </v-col>

            <v-col cols="12 col-sm-6 col-lg-3">
              <v-select
                :items="[{label:'دوره ای',value:1},{label:'کارکردی',value:2},{ value:3, label: 'موردی'}]"
                label="نوع"
                outlined
                dense

                item-text="label"
                v-model="selected_main_op"
                item-value="value"
                single-line
              >
              </v-select>
            </v-col>
            <v-col cols="12 col-sm-6 col-lg-3" v-if="selected_main_op==1 || selected_main_op==2">
              <v-select
                :items="[{ value: 1, label: 'روزانه'},{ value:2, label: 'ماهانه'},{ value:3, label: 'سالانه'}]"
                label="نوع دوره"
                outlined
                item-text="label"
                v-model="selected_duration"
                item-value="value"
                single-line
                dense
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">

            <v-col cols="12">

              <v-row v-if="selected_main_op==1 || selected_main_op==2  ">
                <v-col cols="7">
                  <v-row>
                    <v-col cols="3">
                      <label> تاریخ شروع </label>
                    </v-col>
                    <v-col cols="9">
                      <date-picker
                        v-model="operation_date"
                        display-format="jYYYY/jMM/jDD"
                      ></date-picker>
                    </v-col>
                  </v-row>

                </v-col>
                <v-col cols="5">
                  <v-text-field label="طول دوره"
                                outlined
                                dense
                                type="number"
                                v-model="operation_duration"/>

                </v-col>
              </v-row>

            </v-col>
            <v-col cols="12" v-if="selected_main_op==3">

              <v-row v-for="(irregular,index) in irregular_dates">
                <v-col cols="5">
                  <label> تاریخ اعلام </label>
                </v-col>
                <v-col cols="5">
                  <label> تاریخ خاتمه </label>
                </v-col>
                <v-col cols="5">
                  <date-picker
                    v-model="irregular.date"
                    display-format="jYYYY/jMM/jDD"
                    placeholder="تاریخ اعلام"

                  ></date-picker>
                </v-col>
                <v-col cols="5">
                  <date-picker
                    v-model="irregular.end_date"
                    display-format="jYYYY/jMM/jDD"
placeholder="تاریخ خاتمه"
                  ></date-picker>
                </v-col>
                <v-col cols="1">
                  <button

                    @click="irregular_dates.push({})" size="sm" color="primary">
                    <v-icon>mdi-plus</v-icon>
                  </button>

                </v-col>
              <v-col cols="1">
                <button

                  v-if="irregular_dates.length>1" @click="irregular_dates.splice(index,1)" size="sm"
                  color="primary">
                  <v-icon>mdi-minus</v-icon>
                </button>
              </v-col>
              </v-row>

            </v-col>

            <v-row v-if="selected_main_op==2">
              <v-col cols="12">
                موارد کارکردی

              </v-col>
              <v-col cols="12">
                <v-row v-for="(sub,index) in functional_list" style="border: 1px solid grey">
                  <v-col cols="4">
                    <v-select
                      label="نوع کارکرد"
                      outlined
                      item-text="label"
                      v-model="sub.id"
                      item-value="value"
                      single-line
                      dense
                      :items="function_items"/>
                  </v-col>
                  <v-col cols="4">

                    <v-text-field
                      v-model="sub.first_value"
                      outlined
                      dense
                      placeholder="مقدار فعلی"/>
                  </v-col>
                  <v-col cols="2">

                    <v-btn
                      outlined
                      color="dark"
                      @click="functional_list.push({id:0,first_value:''})"
                    >+
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      v-if="index!=0"
                      outlined
                      @click="functional_list.splice(index,1)"
                      color="dark"
                    >-
                    </v-btn>
                  </v-col>

                </v-row>

              </v-col>

            </v-row>
          </v-row>
          <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">
            <v-col cols="12">
              <v-textarea
                label="توضیحات"
                horizontal
                dense

                outlined
                v-model="new_summary"
              />
            </v-col>
          </v-row>

          <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">

            <v-col cols="12 col-sm-6 col-lg-4">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> عامل </label>
                <div class="col-sm-9">

                  <treeselect
                    v-model="new_document_person_amel"
                    :load-options="load_persons"
                    placeholder="جستجو کنید (حداقل 3 حرف)"
                    @select="select_amel"
                    :async="true"
                    :normalizer="normalizer_persons"
                  />

                </div>
              </div>
            </v-col>
            <v-col cols="12 col-sm-6 col-lg-4 ">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> ناظر </label>
                <div class="col-sm-9">

                  <treeselect

                    v-model="new_document_person_nazer"
                    :load-options="load_persons"
                    placeholder="جستجو کنید (حداقل 3 حرف)"
                    @select="select_nazer"
                    :async="true"

                    :normalizer="normalizer_persons"
                  />

                </div>
              </div>
            </v-col>
            <v-col cols="12 col-sm-6 col-lg-4">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> سرپرست </label>
                <div class="col-sm-9">

                  <treeselect

                    v-model="new_document_person_sarparast"
                    :load-options="load_persons"
                    placeholder="جستجو کنید (حداقل 3 حرف)"
                    @select="select_sarparast"
                    :async="true"

                    :normalizer="normalizer_persons"
                  />

                </div>
              </div>
            </v-col>
          </v-row>
          <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">

            <v-col cols="12 col-sm-6 col-lg-6">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> برچسب ها </label>
                <div class="col-sm-9">

                  <treeselect

                    v-model="selected_tags"
                    :options="tm_tags"
                    placeholder="جستجو کنید"
                    :multiple="true"
                    :normalizer="normalizer_tags"
                  />

                </div>
              </div>
            </v-col>
            <v-col cols="12 col-sm-6 col-lg-3">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> نوع اولویت </label>
                <div class="col-sm-9">

                  <v-select
                    :items="[{label:'عادی',value:0},{label:'ضروری',value:1},{label:'ضرروی همراه با پیامک',value:2}]"
                    label="نوع اولویت"
                    outlined
                    dense
                    item-text="label"
                    v-model="selected_priority"
                    item-value="value"
                    single-line
                  >
                  </v-select>
                </div>
              </div>

            </v-col>
            <v-col cols="12 col-sm-6 col-lg-3">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3"> زمان انجام (ساعت)</label>
                <div class="col-sm-9">

                  <v-col col="6">
                    <v-text-field
                      label="زمان انجام (ساعت)"
                      type="number"
                      outlined
                      dense
                      v-model="op_time"/>
                  </v-col>
                  <v-col col="6">
                    <v-text-field
                      label="زمان انجام (دقیقه)"
                      type="number"
                      outlined
                      dense
                      v-model="op_time_min"/>
                  </v-col>
                </div>
              </div>

            </v-col>

            <v-col cols="12" class="req-attachment">
              <div class="card">
                <v-row class="">
                  <v-col cols="9">افزودن پیوست</v-col>
                  <v-col class="text-end" style="padding: 0px" cols="3">
                    <v-btn
                      color="primary"
                      dark
                      @click="select_file()"
                      class="ma-2"
                    >
                      <v-icon
                        dark
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden
                         v-on:change="input_file_changed">
                  <v-row style="margin-bottom: 35px; margin-top: 35px;">
                    <v-col cols="4"
                           v-for="(item, i) in files"
                           :key="i"
                    >
                      <v-icon v-on:click="delete_file(i)" style="color: crimson">
                        mdi-close
                      </v-icon>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                      <img style="height: 100px!important;width: 100px!important;" loading="lazy" :src="item.file"
                           width="100px"
                           height="100px"/>

                    </v-col>
                  </v-row>
                </v-row>

              </div>
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" @click="add_operation()">ثبت وظیفه</v-btn>
            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>

  import { bus } from '../../main'
  import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  export default {
    data () {
      return {
        functional_list: [{ id: 0, first_value: '' }],
        function_items: [],
        operation_date: '',
        op_time: 0,
        op_time_min: 0,
        selected_priority: 0,
        operation_duration: '1',
        irregular_dates: [{ date:'', end_date:'' }],
        tm_tags: [],
        selected_tags: [],
        tm_cats: [],
        selected_cat: 0,
        selected_main_op: 3,
        selected_duration: 0,
        tm_operation: [],
        dialog_operation: false,
        status_items: [{ label: 'انتخاب کنید', value: 0 }, { label: 'ارجاع شد', value: 1 }, {
          label: 'انجام شد',
          value: 2
        }, { label: 'در حال انجام', value: 4 }, { label: 'لغو شد', value: 3 }],
        selected_status: 0,
        selected_record: {},
        change_status_summary: '',
        current_value: '',
        search_user_async: true,
        document_person: null,
        dialog_new: false,
        new_title: '',
        new_summary: '',
        new_document_person_amel: null,
        new_document_person_nazer: null,
        new_document_person_sarparast: null,
        new_document_person_amel_name: '',
        new_document_person_nazer_name: '',
        new_document_person_sarparast_name: '',
        files: [],
        load_persons ({ action, searchQuery, callback }) {
          var self = this
          if (searchQuery.length < 3) {
            return
          }
          if (action === ASYNC_SEARCH) {
            simulateAsyncOperation(() => {
              let options
              const send_data = {
                TxtSearch: searchQuery,
                BranchId: 10
              }
              // formData.append('TxtSearch', searchQuery);
              // formData.append('TxtSearch', searchQuery);

              this.axios.post('https://panel.zoodkomak.com/ZkpAccService/GetWorkersByKeword', send_data, { show_pros: true }).then(function (response) {
                options = response.data.Data

                callback(null, options)

                // localStorage.setItem("api_token", response.data.access_token);
                // self.$router.push({ path: 'notes' });
              })
                .catch(function (error) {
                  console.log(error)
                })

              //  const options = this.get_keywords(searchQuery);
              // const options = [1, 2, 3, 4, 5].map(i => ({
              //     id: `${searchQuery}-${i}`,
              //     name: `${searchQuery}-${i}`,
              // }))
            })
          }
        },
        normalizer_persons (node) {
          return {
            id: node.PersonId,
            label: node.PersonName,
          }
        },
        normalizer_tags (node) {
          return {
            id: node.RecId,
            label: node.Title,
          }
        },

      }
    },
    components: {
      Treeselect,
      datePicker: VuePersianDatetimePicker,

    },
    watch: {},
    mounted () {
      var user_data = JSON.parse(localStorage.getItem('zoodpayam_profile'))

      this.UserId = user_data.UserId
      this.items = JSON.parse(localStorage.getItem('lastChat'))
      // console.log("lastChat", this.items)
      this.irregular_dates = [{ date:this.get_today(), end_date:this.get_today() }],
      this.get_tm_op()
      this.get_tm_tags()
      this.get_tm_cat()
      this.get_tm_func()
      // this.getUserInfo();
      // localStorage.getItem("LastUserInfo")
    },

    methods: {

      get_type_title (id) {
        var txt = ''
        switch (id) {
          case 1:
            txt = 'دوره ای '
            break
          case 2:
            txt = 'کارکردی '
            break
          case 3:
            txt = 'موردی '
            break
        }
        return txt
      },
      get_op_title (id) {
        var txt = ''
        switch (id) {
          case 1:
            txt = 'روزانه'
            break
          case 2:
            txt = 'ماهانه'
            break
          case 3:
            txt = 'سالانه'
            break
          case 4:
            txt = 'موردی'
            break
        }
        return txt
      },
      clear_texts () {
        this.functional_list = [{ id: 0, first_value: '' }]
        this.operation_date = ''
        this.op_time = 0
        this.selected_priority = 0
        this.operation_duration = '1'
        this.irregular_dates = [{ date:this.get_today(), end_date:this.get_today() }],
        this.selected_tags = []
        this.selected_cat = 0
        this.selected_main_op = 0
        this.selected_duration = 0
        this.tm_operation = []
        this.dialog_operation = false

        this.selected_status = 0
        this.selected_record = {}
        this.change_status_summary = ''
        this.current_value = ''
        this.search_user_async = true
        this.document_person = null
        this.dialog_new = false
        this.new_title = ''
        this.new_summary = ''
        this.new_document_person_amel = null
        this.new_document_person_nazer = null
        this.new_document_person_sarparast = null
        this.new_document_person_amel_name = ''
        this.new_document_person_nazer_name = ''
        this.new_document_person_sarparast_name = ''
        this.files = []
      },
      select_amel (node) {
        this.new_document_person_amel_name = node.PersonName
      },
      select_nazer (node) {
        this.new_document_person_nazer_name = node.PersonName
      },
      select_sarparast (node) {
        this.new_document_person_sarparast_name = node.PersonName
      },
      go_back () {
        localStorage.setItem('LastUserInfo', null)
        if (!this.get_ismobile()) {
          bus.$emit('contact_chat_info_update', true)
        } else {
          this.$router.go(-1)
        }
      },
      get_tm_func () {
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        const send_data = {
          UserId: user_id,
        }
        const options = {}
        var self = this
        this.axios.post('https://panel.zoodkomak.com/Maintenance/GetFunctionalGoals', send_data, options)
          .then(response => {
            self.function_items = [{ label: 'انتخاب کنید', value: 0 }]
            response.data.Data.forEach(function (val) {
              self.function_items.push({ label: val.FunctionalGoalTitle, value: val.FunctionalGoalId })
            })
          }).catch(e => {
          // this.errors.push(e)
        })
      },

      get_tm_cat () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var phone = localStorage.getItem('zoodpayam_phone')
        phone = phone.replace('+98', '')
        var password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          UserId: user_id,
        }
        this.axios.post('https://panel.zoodkomak.com/Maintenance/GetCats', send_data, {})
          .then(response => {
            if (response.data.Error == 0) {
              self.tm_cats = response.data.Data
            } else {
            }
          }).catch(e => {

        })
      },
      get_tm_op () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var phone = localStorage.getItem('zoodpayam_phone')
        phone = phone.replace('+98', '')
        var password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          UserId: user_id,
          CurrentDate: new Date().toJSON().slice(0, 10),
        }

        this.axios.post('https://panel.zoodkomak.com/Maintenance/GetLastCheckListByUserId', send_data, {})
          .then(response => {
            if (response.data.Error == 0) {
              self.tm_operation = JSON.parse(response.data.Data.Items)
            } else {
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          // this.errors.push(e);

        })
      },
      get_tm_tags () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var phone = localStorage.getItem('zoodpayam_phone')
        phone = phone.replace('+98', '')
        var password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          UserId: user_id,
          CurrentDate: new Date().toJSON().slice(0, 10),
        }

        this.axios.post('https://panel.zoodkomak.com/Maintenance/GetOpTags', send_data, {})
          .then(response => {
            if (response.data.Error == 0) {
              self.tm_tags = response.data.Data
            } else {
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          // this.errors.push(e);

        })
      },
      add_status () {
        var self = this

        this.change_status_modal = false

        var errormsg = ''
        if (this.change_status_summary == '') {
          errormsg = 'لطفا توضیحات را وارد کنید'
          bus.$emit('show_toast', [2000, errormsg])

          return false
        } else if (this.selected_status == 0) {
          errormsg = 'لطفا وضعیت را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])

          return false
        } else if (this.selected_status == 1 && this.document_person == null) {
          errormsg = 'لطفا کاربر را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        } else if (this.selected_record.MainOperationType == 2 && this.current_value == '') {
          errormsg = 'لطفا مقدار فعلی را وارد کنید'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        }

        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        // var send_data = {
        //     "Title": this.cat_title,
        // };
        var person = this.document_person
        if (person == null) {
          person = []
        }
        const send_data = {
          RecId: this.selected_record.RecId,
          UserId: user_id,
          StatusId: this.selected_status,
          Receivers: person,
          Summary: this.change_status_summary,
          PMStatusId: 0,

        }
        if (self.selected_record.MainOperationType == 2) {
          send_data.NewValue = this.current_value
        } else {
          send_data.NewValue = 0
        }
        var url = 'https://panel.zoodkomak.com/Maintenance/AddOperationStatus'

        const options = {}
        this.axios.post(url, send_data, options)
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.Message])

            if (response.data.Error == 0) {
              self.selected_status = 0
              self.change_status_summary = ''
              self.get_tm_op()
              self.dialog_operation = false
            }
          }).catch(e => {
          // this.errors.push(e)
        })
      },

      add_operation () {
        var self = this

        var errormsg = ''

        if (this.new_title == '') {
          errormsg = 'لطفا عنوان را وارد کنید'
          bus.$emit('show_toast', [2000, errormsg])

          return false
        } else if (this.new_summary == '') {
          errormsg = 'لطفا توضیحات را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])

          return false
        } else if (this.new_document_person_amel == null) {
          errormsg = 'لطفا عامل را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        } else if (this.new_document_person_nazer == null) {
          errormsg = 'لطفا ناظر را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        } else if (this.new_document_person_sarparast == null) {
          errormsg = 'لطفا سرپرست را مشخص کنید.'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        } else if (this.operation_date == '' && this.selected_main_op != 3) {
          errormsg = 'لطفا تاریخ شروع را وارد کنید.'
          bus.$emit('show_toast', [2000, errormsg])
          return false
        }

        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        // var send_data = {
        //     "Title": this.cat_title,
        // };
        var person = this.document_person
        if (person == null) {
          person = []
        }

        var goal_list = []
        if (this.selected_duration == 2) {
          this.functional_list.forEach(function (val) {
            if (val.id != 0) {
              goal_list.push({
                FunctionalGoalId: val.id,
                CurrentValue: val.first_value,
              })
            }
          })
        }
//* ********************************************
        var irregular_send = []
        for (var i = 0; i < this.irregular_dates.length; i++) {
          if (this.irregular_dates[i].date != null) {
            irregular_send.push({
              ItemFirstDate:this.irregular_dates[i].date,
              ItemEndDate:this.irregular_dates[i].end_date
            })
          }
        }

        var tags_send = []
        for (var i = 0; i < this.selected_tags.length; i++) {
          if (this.selected_tags[i] != null) {
            tags_send.push(this.selected_tags[i])
          }
        }

//* ********************************************
        const send_data = {
          UserId: user_id,
          Id: 0,
          AgentId: this.new_document_person_amel,
          SupervisorId: this.new_document_person_nazer,
          ManagerId: this.new_document_person_sarparast,
          AgentName: this.new_document_person_amel_name,
          SupervisorName: this.new_document_person_nazer_name,
          ManagerName: this.new_document_person_sarparast_name,
          HasPriority: this.selected_priority,
          OperationCode: 0,
          OperationTitle: this.new_title,
          OperationType: this.selected_duration,
          MainOperationType: this.selected_main_op,
          CatId: this.selected_cat,
          CatTitle: 0,
          StartDate: this.operation_date,
          CounterNo: this.operation_duration,
          Summary: this.new_summary,
          IsShow: 0,
          OpTime: parseInt(parseInt(this.op_time) * 60) + parseInt(this.op_time_min),
          GoalInfos: goal_list,
          Irregular: irregular_send,
          Tags: tags_send,

        }
        if (send_data.MainOperationType == 3) {
          send_data.MainOperationType = 1
          send_data.OperationType = 4
          send_data.CounterNo = 0
        }
        var url = 'https://panel.zoodkomak.com/Maintenance/AddOperationEvryone'

        const options = {}
        this.axios.post(url, send_data, options)
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.Message])

            if (response.data.Error == 0) {
              self.dialog_new = false
              if (self.files.length > 0) {
                // self.upload_image(response.data.Data.Id)
                self.upload_image(0, response.data.Data)
              } else {
                self.get_tm_op()
                self.clear_texts()
              }
            }
          }).catch(e => {
          // this.errors.push(e)
        })
      },
      add_operation_attach (op_id) {
        var self = this

        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId

        var person = this.document_person
        if (person == null) {
          person = []
        }
        var attachs = []
        this.files.forEach(function (val) {
          val.id = op_id
          attachs.push({ id: op_id, ArchiveId: val.ArchiveId, ImageName: val.ImageName })
        })
        const send_data = {
          UserId: user_id,
          inputs: JSON.stringify(attachs),

        }

        var url = 'https://panel.zoodkomak.com/Maintenance/AddOperationAttach'

        const options = {}
        this.axios.post(url, send_data, options)
          .then(response => {
            if (response.data.Error == 0) {
              self.dialog_new = false
              self.files = []
              self.get_tm_op()
              self.clear_texts()
            }
          }).catch(e => {
          // this.errors.push(e)
        })
      },
      input_file_changed () {
        console.log('input_file_changed')
        var self = this

        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files
        // if (f != null) {
        reader.onloadend = function () {
          // console.log(reader.result);
          if (!reader.result.startsWith('data:image/webp')) {
            self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
              // $("body").append(newImg[0]);
              // console.log("resized", newImg[0].src)
              var obj = { file: newImg[0].src, preview: reader.result, upload: 0 }
              self.files.push(obj)
              reader = null
              f = null
              document.getElementById('fileUpload').files = null
              obj = null
            })
            // console.log(obj)
          } else {
            bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
          }
        }
        reader.readAsDataURL(f[0])

        // }
      },
      async resizeBase64Img (base64, minimum) {
        // try {

        var canvas = document.createElement('canvas')

        var deferred = $.Deferred()
        $('<img/>').attr('src', base64).load(function () {
          var last_width = this.width
          var last_height = this.height

          if (last_width > last_height) {
            last_width = (last_width * minimum) / last_height
            last_height = minimum
          } else {
            last_height = (last_height * minimum) / last_width
            last_width = minimum
          }
          canvas.width = last_width
          canvas.height = last_height
          var context = canvas.getContext('2d')

          // console.log(this.width, this.height)
          context.scale(last_width / this.width, last_height / this.height)
          context.drawImage(this, 0, 0)

          deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
        })
        return deferred.promise()
        // } catch (e) {
        //   bus.$emit('show_toast', [3000, "error on Base64Img"])
        //
        // }
      },
      upload_image (index, op_id) {
        var self = this
        var form_data = new FormData()
        form_data.append('Format', 'png')
        form_data.append('DocType', 1)
        var my_file = this.files[index].file

        var file = this.dataURLtoFile(my_file, 'attach.png')
        form_data.append('Picture', file)

        this.axios.post('https://panel.zoodkomak.com/Maintenance/OpUploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1
              self.files[index].ArchiveId = response.data.ArchiveId
              self.files[index].ImageName = response.data.ImageName
              if (index < self.files.length - 1) {
                self.upload_image(index + 1, op_id)
              } else {
                self.add_operation_attach(op_id)
              }

              // var finish_all = true;
              //   self.files.forEach(function (number) {
              //     if (number.upload != 1) {
              //       finish_all = false;
              //     }
              //   });
              // if (finish_all) {
              //   self.files[0].upload = 1;
              //
              // }
            } else {
              self.files[index].upload = 2
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        try {
          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, { type: mime })
        } catch (e) {
          bus.$emit('show_toast', [3000, 'error on dataURLtoFile'])
        }
      },
      select_file () {
        document.getElementById('fileUpload').click()
      },
      delete_file (index) {
        this.files.splice(index, 1)
      },
    },

  }
</script>
